import type { IconNode } from '../types';

/**
 * @name nepali-rupee
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMTQgMjAtOC04aDRjNS4zMzMgMCA1LjMzMy04IDAtOCIgLz4KICA8cGF0aCBkPSJNMTQgOGM0LjA3OCAwIDUuMDM4IDQuNjc4IDIuODggNi44OCIgLz4KICA8cGF0aCBkPSJNNiA0aDEyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/nepali-rupee
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const NepaliRupee: IconNode = [
  ['path', { d: 'm14 20-8-8h4c5.333 0 5.333-8 0-8' }],
  ['path', { d: 'M14 8c4.078 0 5.038 4.678 2.88 6.88' }],
  ['path', { d: 'M6 4h12' }],
];

export default NepaliRupee;
